import { getPlayerPoints } from './points';

// Acima disso a busca exaustiva fica lenta no tablet (ex.: C(30,6) = 593.775); usa-se a gulosa.
export const MAX_EXHAUSTIVE_COMBINATIONS = 200000;

const isFemale = (p) => p.gender === 'F';

const countCombinations = (n, k) => {
  let result = 1;
  for (let i = 1; i <= k; i += 1) {
    result = (result * (n - k + i)) / i;
    if (result > MAX_EXHAUSTIVE_COMBINATIONS) return Infinity;
  }
  return result;
};

// Gulosa: a cada vaga escolhe quem deixa a média restante mais próxima do alvo.
const greedyCombination = (candidates, size, baseScore, targetScore, maxFemales) => {
  const chosen = [];
  const remaining = [...candidates];
  let sum = baseScore;
  let femalesLeft = maxFemales;
  while (chosen.length < size) {
    const slotsLeft = size - chosen.length;
    const desired = (targetScore - sum) / slotsLeft;
    let bestIdx = -1;
    let bestDiff = Infinity;
    for (let idx = 0; idx < remaining.length; idx += 1) {
      const p = remaining[idx];
      if (!isFemale(p) || femalesLeft > 0) {
        const d = Math.abs(getPlayerPoints(p) - desired);
        if (d < bestDiff) { bestDiff = d; bestIdx = idx; }
      }
    }
    if (bestIdx === -1) break;
    const [picked] = remaining.splice(bestIdx, 1);
    chosen.push(picked);
    sum += getPlayerPoints(picked);
    if (isFemale(picked)) femalesLeft -= 1;
  }
  return chosen;
};

// Escolhe `slotsNeeded` jogadores cuja soma deixa (baseScore + soma) mais próxima de targetScore.
// Respeita maxFemales (modo restrito). Percorre as combinações na mesma ordem de antes, sem
// guardá-las em memória; empates ficam com a primeira encontrada.
export const findBestCombination = (
  candidates,
  slotsNeeded,
  baseScore,
  targetScore,
  maxFemales = Infinity,
) => {
  const femaleCount = candidates.filter(isFemale).length;
  const size = Math.min(
    slotsNeeded,
    candidates.length - femaleCount + Math.min(femaleCount, Math.max(0, maxFemales)),
  );
  if (size <= 0) return [];
  if (candidates.length <= size) return candidates;

  if (countCombinations(candidates.length, size) > MAX_EXHAUSTIVE_COMBINATIONS) {
    return greedyCombination(candidates, size, baseScore, targetScore, maxFemales);
  }

  const points = candidates.map(getPlayerPoints);
  const females = candidates.map(isFemale);
  const combo = [];
  let bestCombo = null;
  let bestDiff = Infinity;

  const combine = (start, sum, femalesUsed) => {
    if (combo.length === size) {
      const diff = Math.abs((baseScore + sum) - targetScore);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestCombo = [...combo];
      }
      return;
    }
    for (let i = start; i < candidates.length; i += 1) {
      const nextFemales = femalesUsed + (females[i] ? 1 : 0);
      if (nextFemales <= maxFemales) {
        combo.push(i);
        combine(i + 1, sum + points[i], nextFemales);
        combo.pop();
      }
    }
  };
  combine(0, 0, 0);

  return bestCombo ? bestCombo.map((i) => candidates[i]) : [];
};
